/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import './Auth.style.css';
import { connect } from "react-redux";
import { AppSiteWrapper } from '../../components/wrappers/SiteWrapper';
import { Button, Card, Checkbox, Col, Form, Input, InputNumber, message, Row, Typography } from 'antd';
import LogoIcon from '../../assets/images/Logo.svg';
import hover from '../../assets/images/Vector.png';
import IllustrationsIcon from '../../assets/images/Illustrations.svg';
import { emailOrGlobalMobile } from '../../services/helpers';
import { goToLink, removeUser, setUser } from '../../services/authService';
import AuthModel from './Auth.model';
import EditProfileModel from '../edit-profile/EditProfile.model';


class AuthUi extends Component<any, any> {

    state: any = {
        remmeber: true,
        errorMsg: '',
        loginUsingCode: false,
        showSMSSent: false,
    }
    phoneNumber: any;

    componentDidMount() {
        this.props.start()
    }

    login = async (form: any) => {
        const { username, password } = form;
        this.props.login(username, password).then(async (result: any)=>{
            if (result && result?.error) {
                let msg= "";
                switch (result?.error?.code) {
                    case -32609:
                        msg = "اسم المستخدم غير فعال أو غير مستخدم";
                        break;
                    case -32610:
                        msg = "كلمة المرور غير صحيحة";
                        break;
                    case -11001:
                        msg = "هذا المستخدم محظور";
                        break;
                    default:
                        msg = "اسم المستخدم أو كلمة المرور غير صحيحة";
                }
                if(msg == ""){
                    msg = "فشلت عملية تسجيل الدخول"
                }
                this.setState({errorMsg: msg})
            }
            else {
                setUser(result)
                await this.props.userDetails()
                if(this.props?.user?.result?.profile?.backoffice_operation?.userType == 'CAR_DEALERSHIP' 
                    || (this.props?.user?.result?.profile?.backoffice_operation?.userType == 'SELLER' && !this.props?.user?.result?.profile?.backoffice_operation?.isGarage)){
                        removeUser();
                        goToLink('/login');
                }
                else{
                    JSON.parse(localStorage.getItem('permissions') || '')?.includes('SUMMARY_REPORT') ? goToLink('/summary-report') : goToLink(`/claims`);
                }
            }
        })        
    };

    phoneLogin = async () => {
        const { entered_sms_code, token } = this.state;
        let response = await this.props.phoneLogin(entered_sms_code, token);
        if(response?.error){
            message.error('يرجى التحقق من الرمز المدخل')
            this.setState({entered_sms_code: null})
        }
        else{
            setUser(response?.result)
            await this.props.userDetails()
            if (this.props?.user?.result?.profile?.backoffice_operation?.userType == 'CAR_DEALERSHIP'
                || (this.props?.user?.result?.profile?.backoffice_operation?.userType == 'SELLER' && !this.props?.user?.result?.profile?.backoffice_operation?.isGarage)) {
                    removeUser();
                goToLink('/login');
            }
            else {
                JSON.parse(localStorage.getItem('permissions') || '')?.includes('SUMMARY_REPORT') ? goToLink('/summary-report') : goToLink(`/claims`);
            }
        }
    }

    requestSMSCodeForLogin = async (values:{phoneNumber: string}) => {
        this.phoneNumber = values?.phoneNumber;
        let response = await this.props.requestSMSCode(values?.phoneNumber);
        if(response?.result?.token){
            this.setState({showSMSSent: true, token: response?.result?.token})
        }
        else{
            if(response?.error?.code == -34252){
                message.error(' رقم الهاتف غير موجود، يرجى التحقق منه ')
            }
            else if(response?.error?.code == -11001){
                message.error(' هذا المستخدم محظور ')
            }
            else if(response?.error?.code == -34253){
                message.error(' رقم الهاتف مكرر، يرجى التواصل مع MCM لإصلاح المشكلة ')
            }
            else{
                message.error('حدث خطأ ما، يرجى المحاولة مرة أخرى')
            }
        }
    }

    render() {
        const { loading }: any = this.props;
        const { loginUsingCode, showSMSSent, entered_sms_code } = this.state;
        const validationMessages = {
            required: `${'حقل'}'\${label}' ${'مطلوب'}!`,
        };
        const pattern: any = {
            pattern: emailOrGlobalMobile,
            message: ('الرجاء ادخال البريد الالكتروني')
        }
        const phonePattern: any = {
            pattern: emailOrGlobalMobile,
            message: ('الرجاء إدخال رقم الهاتف')
        }
        return <AppSiteWrapper className='AuthBody' style={{
            justifyContent: 'space-between',
            display: 'flex',
            flex: 'row',
            flexDirection: 'row',
            backgroundColor: 'white'
        }}>
            <div style={{
                justifyContent: 'center',
                width: '40%',
                flexDirection: 'row',
                backgroundColor: "#021D49",
            }}>
                <img style={{maxWidth: '25%', maxHeight: '25%', transform: 'rotate(180deg)', transition: 'transform 150ms ease'}}
                    src={hover} />
                <Col className='logo' style={{ paddingTop: '5%' }}>

                    <img style={{ maxWidth: '20%', alignContent: 'center', marginRight: '35%', marginLeft: '35%', marginBottom: '10%' }} src={LogoIcon} />
                    <img style={{ paddingBottom: '7%', maxWidth: '90%', alignContent: 'center' }} src={IllustrationsIcon} />
                </Col>

            </div>
            <div style={{ width: '60%', height: '100%' }}>
                <Col>
                    <div className='login'>

                        {!showSMSSent && <Card style={{ fontFamily: 'Cairo' }} bordered={false}>
                            <div>
                                <Typography.Title level={3} style={{ width: '100%', marginBottom: '5%', color: '#021D49' }}>{('تسجيل الدخول')}</Typography.Title>
                            </div>
                            {loginUsingCode == false && <Form layout={"vertical"} onFinish={this.login} autoComplete="off" //requiredMark={false}
                                validateMessages={validationMessages}>
                                <Form.Item label={('اسم المستخدم')} name={'username'}
                                    rules={[{ required: true }, pattern]}>
                                    <Input className='input' style={{ direction: 'ltr' }} placeholder='example@youremail.com' />
                                </Form.Item>
                                <Form.Item label={('كلمة المرور')} name={'password'} rules={[{ required: true }]}>
                                    <Input.Password className='input' type={"password"} placeholder={'كلمة المرور الخاصة بك'} />
                                </Form.Item>
                                <Form.Item name="remember" valuePropName="checked" >
                                    <Checkbox value={this.state.remmeber} onChange={(value: any) => { this.setState({ remmeber: value.target?.checked }) }}>تذكرني</Checkbox>
                                </Form.Item>
                                <Form.Item >
                                    <Button className='loginbtn' style={{ width: '100%', height: '100%' }} type={"primary"} loading={loading}
                                        htmlType="submit">{('تسجيل الدخول')}</Button>
                                    <Col style={{ color: 'red', fontFamily: 'Cairo' }} >{this.state?.errorMsg}</Col>
                                </Form.Item>
                                <Row className='link' onClick={() => this.setState({loginUsingCode: true})}>الانتقال لتسجيل الدخول باستخدام رقم الهاتف</Row>
                            </Form>}
                            {loginUsingCode == true && <Form layout={"vertical"} onFinish={this.requestSMSCodeForLogin} autoComplete="off">
                                <Form.Item label={('رقم الهاتف')} name={'phoneNumber'}
                                    rules={[{ required: true }, phonePattern]}>
                                    <Input className='input' style={{ direction: 'ltr' }} placeholder='أدخل رقم الهاتف الخاص بك' />
                                </Form.Item>
                                <Form.Item >
                                    <Button className='loginbtn' style={{ width: '100%', height: '100%' }} type={"primary"} loading={loading}
                                        htmlType="submit">{('إرسال رمز تأكيد')}</Button>
                                    <Col style={{ color: 'red', fontFamily: 'Cairo' }} >{this.state?.errorMsg}</Col>
                                </Form.Item>
                                <Row className='link' onClick={() => this.setState({loginUsingCode: false})}>الانتقال لتسجيل الدخول باستخدام اسم المستخدم</Row>
                            </Form>}
                        </Card>}
                        {
                            showSMSSent && <Card style={{ fontFamily: 'Cairo' }} bordered={false} className='sms-sent-card'>
                                <Col>
                                    <Row justify={'center'} className='large-text'>أدخل الرمز الذي أرسلناه إلى</Row>
                                    <Row justify={'center'} className='large-text'>{this.phoneNumber}</Row>
                                    <Row justify={'center'} className='small-text'>لقد أرسلنا رمزاً مكوناً من 4 أرقام إلى رقم هاتفك </Row>
                                    <Row justify={'center'} className='small-text'>يرجى إدخال الرمز لتتمكن من تسجيل الدخول.</Row>
                                    <Row justify={'center'} className='link' onClick={() => {
                                        this.setState({showSMSSent: false, loginUsingCode: true, token: null})
                                        this.phoneNumber = null;
                                    }}>تغيير الرقم</Row>
                                    <Row className='verification-code-row'>
                                        <InputNumber min={1000} max={9999} className='verification-code' 
                                        onChange={(value: number | null) => {
                                            this.setState({ entered_sms_code: value });
                                        }} />
                                    </Row>
                                    <Row>
                                        <Button type={'primary'} disabled={!entered_sms_code || typeof entered_sms_code !== "number" || entered_sms_code.toString()?.length != 4} style={{ borderRadius: '5px', margin: 'auto', marginTop: '18px' }} onClick={() => this.phoneLogin()}>أرسل الرمز</Button>
                                    </Row>
                                </Col>
                            </Card>
                        }
                    </div>

                </Col>
                <Row justify='space-between' align='middle' >


                    <Col />
                    <img style={{
                        marginTop: '15vh',
                        maxWidth: '25%', maxHeight: '25%',
                        transform: 'rotate(360deg)',
                        transition: 'transform 150ms ease',
                    }} src={hover} />
                </Row>
            </div>

        </AppSiteWrapper>;
    }

}

const mapStateToProps = (state: any, ownProps: any) => ({ ...state.auth, ...state.editProfile });
const mapDispatchToProps = (dispatch: any) => ({
    login: (username: string, password: string) => dispatch(AuthModel.loginAction(username, password)),
    start: () => dispatch(AuthModel.start()),
    userDetails: () => dispatch(EditProfileModel.userDetailsAction()),
    requestSMSCode: (phone: string) => dispatch(AuthModel.requestSMSCodeAction(phone)),
    phoneLogin: (smsCode: number, token: string) => dispatch(AuthModel.loginWithSMSCodeAction(smsCode, token))
});
export default (connect(mapStateToProps, mapDispatchToProps)(AuthUi));
